import { makeStyles } from "@material-ui/core";
import { Button } from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import { useSetRecoilState } from "recoil";
import { IOmniumType } from "../../../../Models/Entities";
import { BASE_URL, sendData } from "../../../../Models/Fetcher";
import { popupState, toastState } from "../../../../Store/atoms";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";
import TextValueInput from "../../TextValueInput";
import "./../popup.css";

interface IEditTypePopupProps {
  type: IOmniumType;
  typeNumber: number;
}

const useStyles = makeStyles({
  confirmButton: {
    marginLeft: "1rem",
  },

  closeButton: {
    marginRight: "1rem",
  },
});

export default ({ type, typeNumber }: IEditTypePopupProps) => {
  const setPopup = useSetRecoilState(popupState);
  const { handleSubmit, control } = useForm();
  const setToast = useSetRecoilState(toastState);
  const styles = useStyles();
  blurRoot();

  const editType = async (data: any) => {
    const url = `${BASE_URL}type/${typeNumber}/${type.id}`;

    const response = await sendData(url, "PUT", { name: data.name });
    handleClose();
    if (response.status !== 200) {
      setToast({
        message: response.data.message,
        severity: "error",
        open: true,
      });
      return;
    }

    window.location.reload();
  };

  const handleClose = () => {
    setPopup(null);
    unBlurRoot();
  };

  return (
    <div className="general-popup">
      <div>{type.name}</div>
      <form className="general-popup-form" onSubmit={handleSubmit(editType)}>
        <TextValueInput
          name={"name"}
          control={control}
          required={true}
          label={"New Type name"}
          errorMsg={"Type name must be filled"}
          defaultValue={""}
        />
        <div className="general-popup-form__button-control">
          <Button
            className={styles.closeButton}
            variant="contained"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={styles.confirmButton}
            type="submit"
            variant="contained"
            color="primary"
          >
            Confirm
          </Button>
        </div>
      </form>
    </div>
  );
};
